export const BIZLY_OS_ROLES = {
    ADMIN: 'administrator',
};

export const BIZLY_PLATFORM_ROLES = {
    ADMIN_ROLE_ID: 100,
    TEAM_MEMBER_ROLE_ID: 200,
};

export const USER_ACCOUNT_STATUS = {
    ACTIVE_ID: 1,
    PENDING_ID: 2,
    REJECTED_ID: 4,
};
